import authRoles from 'app/auth/authRoles';
import { FuseLoadable } from '@fuse';

export const SupplyGenerator = {
    auth: authRoles.processor,
    routes: [
        {
            path: '/supply-generator',
            component: FuseLoadable({ loader: () => import('./SupplyGenerator') }),
        },
    ],
};

export default [SupplyGenerator];
